<ng-content select="td-wb-page-header-back-button" />
<div class="td-wb-page-header__container">
  <h1 class="td-wb-page-header__title">
    <ng-content select="td-wb-page-header-title" />
  </h1>
  <ng-content select="td-wb-page-header-date" />
</div>
<ng-content select="td-wb-page-header-toolbar" />
